import { ComponentPaintCollection } from "@omni/types/components/paintConfigurator/paintCollection.model";
import { cn } from "@omni/utils/styles";

import { useColorsContext } from "@/components/PaintConfigurator/components/colors/context/colors.context";
import { FilterButton } from "@/components/PaintConfigurator/components/shared/filter/filterButton";
import { usePaintConfiguratorContext } from "@/components/PaintConfigurator/context/paintConfigurator.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

const Collections = ({ className }: Props) => {
    const { t } = useGranite();
    const { collections, selectedCollection, setSelectedCollection } =
        usePaintConfiguratorContext();
    const { setSelectedFamily } = useColorsContext();

    const handleOnClick = (collection: ComponentPaintCollection) => () => {
        setSelectedCollection(collection.id);
        setSelectedFamily(undefined);
    };

    return (
        <div className={cn("tw:flex tw:flex-col tw:gap-2", className)}>
            <div className={cn("tw:font-bold")}>
                {t("paintConfigurator.color.filters.collections.title")}
            </div>
            <ul className={cn("tw:flex tw:gap-2 tw:flex-wrap tw:mb-0")}>
                {collections.map((collection) => (
                    <li key={collection.id}>
                        <FilterButton
                            onClick={handleOnClick(collection)}
                            isSelected={
                                collection.id === selectedCollection?.id
                            }
                            label={collection.name}
                            className={cn("tw:w-full")}
                        >
                            {collection.name}
                        </FilterButton>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export { Collections };
